import DashboardCard, {
  DashboardCardDescription,
} from '@Dashboard/Layout/DashboardCard';
import DashboardLayout from '@Dashboard/Layout/DashboardLayout';
import TimeRangeSelector from '@Dashboard/TimeRangeSelector';
import { useDashboardDaysStore } from '@Models/useDashboardDaysModel';
import { Box, Divider } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import TopAccountTakeoverRiskChart from './chart';
import AccountTakeoverRiskTable from './table';
import ContextMenu from '@Components/ContextMenu';

const TopAccountTakeoverRisk = (props: { insightsData: any }) => {
  const { t } = useTranslation();

  const daysModel = useDashboardDaysStore();

  return (
    <DashboardLayout
      title={t('riskUser.sender.malicious')}
      barColor="#42CC79"
      titleBar={<TimeRangeSelector widgetId="TopAccountTakeoverRiskChart" />}
    >
      <DashboardCard height="100%" width="100%" column={2}>
        <Box>
          <DashboardCardDescription>
            {t('riskUser.sender.maliciousDesc')}
          </DashboardCardDescription>
          <TopAccountTakeoverRiskChart
            insightsData={props?.insightsData}
            day={daysModel.days['TopAccountTakeoverRiskChart']}
          />
          <Divider orientation="horizontal" position="relative" mb="24px" />
          <AccountTakeoverRiskTable
            insightsData={props?.insightsData}
            day={daysModel.days['TopAccountTakeoverRiskChart']}
            appendContextMenu={{
              columnIndex: 0,
              enabled: true,
              component: (user: string) => {
                return <ContextMenu user={user}></ContextMenu>;
              },
            }}
          />
        </Box>
      </DashboardCard>
    </DashboardLayout>
  );
};

export default TopAccountTakeoverRisk;
